// aiSmallTalk.ts
export const getAIChatResponse = (q: string) => {
  q = q.toLowerCase().trim();

  const rules: { test: RegExp | string; response: string | string[] }[] = [
    {
      test: /^(hi|hello|hey|hii|hlo|hola|yo)\b/,
      response: [
        "Hey there! 👋",
        "Hello! How can I help you today? 🙂",
        "Hi! What can I do for you? 😄",
        "Hey! Need leave help or want to open a menu? 😎",
      ],
    },
    { test: "good morning", response: "🌅 Good morning! Ready to start the day?" },
    { test: "good afternoon", response: "☀️ Good afternoon!" },
    { test: "good evening", response: "🌇 Good evening!" },
    { test: "good night", response: "🌙 Good night! Sleep well." },

    {
      test: "who are you",
      response:
        "I'm LeadChain AI 🤖 — your assistant for leave requests, menu search & quick help!",
    },
    {
      test: "what can you do",
      response:
        "I can help with:\n• Applying leave\n• Canceling leave\n• Opening menus\n• Answering simple questions 😄",
    },
    { test: "help", response: "How can I assist you today? 😊" },

    { test: "thank", response: "You're welcome! 😊" },
  ];

  for (const rule of rules) {
    if (rule.test instanceof RegExp) {
      if (rule.test.test(q))
        return Array.isArray(rule.response)
          ? rule.response[Math.floor(Math.random() * rule.response.length)]
          : rule.response;
    } else {
      if (q.includes(rule.test))
        return Array.isArray(rule.response)
          ? rule.response[Math.floor(Math.random() * rule.response.length)]
          : rule.response;
    }
  }

  return null;
};
